export default __webpack_public_path__ + "static/media/Shipstation.c7479c6c.xlsx";